import type { IEventChannel } from "../model/Models";
import type Util from "./util";

/**
 * Simple wrapper for marketing-related events.
 */
export default class TrackingEvents {
    private logging: boolean;

    // todo: we should probably cap this
    /** Store events. if a new subscriber comes on board we'll give them a run down of what they missed. */
    private hist: any[];

    /** Tracking events channel */
    public channel: IEventChannel;

    public readonly EVENTS = {
        tracking: "tracking",
        trackingError: "trackingError"
    };

    constructor(util: Util) {
        this.logging = false;
        this.hist = [];

        this.channel = util.createEventChannel(this.EVENTS, "es.util.TrackingEvents");
    }

    /**
     * 
     * @returns 
     */
    isLogging(): boolean {
        return this.logging;
    }

    /**
     * 
     * @param enabled 
     */
    setLogging(enabled: boolean) {
        this.logging = enabled;
    }
        
    /**
     * Default subscribe method for tracking events (convenience method for es.util.TrackingEvents.channel.addListener("tracking", fn))
     * Note: a new subscriber will be instantly updated on any events they missed.
     */
    subscribe(fn: Function, eventType = this.EVENTS.tracking) {
        // first
        for (let i = 0; i < this.hist.length; i++) {
            fn(this.hist[i]);
        }

        this.channel.addListener(eventType, fn);
    }
    
    /**
     * Default fire method for tracking events (convenience method for es.util.TrackingEvents.channel.fireEvent("tracking", fn))
     * The name 'push' was just inherited from GA's API
     */
    push(arr: any[], eventType = this.EVENTS.tracking) {
        if (this.logging) {
            es.log.info("event", arr, this.hist.length); // handy way of tracking events while developing
        }

        this.hist.push(arr);
        this.channel.fireEvent(eventType, arr);
    }
    
    /**
     * Very Tornado-specific method to determine which page user is on
     * @TODO: this is very tornado app specific. Move to Tornado app from API.
     */
    getLocation(href: string): string {
        if (href.search("home.jsp") > -1) {
            return 'HM';//Home
        } else if (href.search("map.jsp") > -1) {
            return 'VM';// View_Map
        } else if (href.search("locations.jsp") > -1) {
            return 'ML';// Manage_Locations
        } else if (href.search("style.jsp") > -1) {
            return 'SC';//Style_Color
        } else if (href.search("manageGroupsUsers.jsp") > -1) {
            return 'MG';//Manage_Groups_Users
        } else if (href.search("territories.jsp") > -1) {
            return 'MT';//Manage_Territories
        } else if (href.search("directions.jsp") > -1) {
            return 'RT';//Routing
        }  else if (href.search("accountSettings.jsp") > -1) {
            return 'AS';//Account_Settings
        }  else if (href.search("scheduler.jsp") > -1) {
            return 'SC';//Scheduler
        } else {
            return 'UL';//Unknown_Location
        }
        // note: special-case for public maps, "PB"

        // HM Home
        // VM View_Map
        // ML Manage_Locations
        // SC Style_Color
        // MG Manage_Groups_Users
        // MT Manage_Territories
        // RT Routing
        // AS Account_Settings
        // SC Scheduler
        // UL Unknown_Location

        // SS Style_Symbol
        // LB Library
        // CP Control_Panel
        // Misc Miscellaneous
        // TI Trial_Intro
        // RT Restriction
        // SC Scheduler

        // Second level xx.YY.zzzz
        // .DS. xx.Dataset_Style.zzzz
        // .TS. xx.Thematic_Symbol.zzzz
        // .TC. xx.Thematic_Color.zzzz
        // .TH. xx.Thematic_Hotspot.zzzz
        // .TZ. xx.Thematic_Size.zzzz
        // .TH. xx.Thematic_Hotspot.zzzz
        // .CP. xx.Control_Panel.zzzz
        // .LT. xx.Loading_Territories.zzzz
        // .AI. xx.Select_Info.zzzz
        // .RF. xx.Restricted_Function.zzzz
        // .AD. xx.Add_Dataset.zzzz
        // .CT. xx.Create_Territory.zzzz
        // .TP. xx.Territory_Panel.zzzz
        // .RP. xx.Routing_Panel.zzzz
        // .TM. xx.Territory_Menu.zzzz
        // .SP. xx.Scheduler_Panel.zzzz
        // .TO. xx.Territory_Optimize.zzzz
        // .BD. xx.Balances_Dialog.zzzz

        // Third level xx.yy.ZZZ
        // xx.yy.Apply_Predef_Ranges xx.yy.Apply_Predefined_Ranges
    }
}
